import _ from "underscore";
import moment from "moment";
import numeral from "numeral";
import 'numeral/locales/ru';
// import 'numeral/locales/en';

export function formatDateTime(dateTime, format, missing) {
  try {
    if (_.isNull(dateTime) || _.isUndefined(dateTime)) return missing || "";
    // return moment.parseZone(dateTime).format(format || "DD.MM.YYYY HH:mm:ss");
    return moment(dateTime).format(format || "DD.MM.YYYY HH:mm:ss");
  } catch (err) {
    // eslint-disable-next-line
    console.error(err);
    return "";
  }
}

/*
 Форматирует число с поддержкой локали

 number - число
 format='0,0' - формат для numeral.js
 locale='ru' - локаль ('ru', 'en')
 missing=null - что возвращать если число отсутствует
*/
export function formatNumber(number, format = '0,0', missing = null) {
  try {
    if (number == null) return missing;

    numeral.locale('ru');
    return numeral(number).format(format);
  } catch (err) {
    // eslint-disable-next-line
    console.error('formatNumber error:', err);
    return '';
  }
}

export function formatBoolean(val) {
  if (_.isNull(val) || _.isUndefined(val)) {
    return "";
  }
  if (val) {
    return "Да";
  }
  return "Нет";
}

export function formatPeriod(dateFrom, dateTo) {
  const period = [];
  if (dateFrom) {
    try {
      period.push("с");
      period.push(moment.parseZone(dateFrom).format("DD.MM.YYYY"));
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
    }
  }
  if (dateTo) {
    try {
      period.push("по");
      period.push(moment.parseZone(dateTo).format("DD.MM.YYYY"));
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
    }
  }
  return period.length > 0 ? period.join(" ") : null;
}
